import { useEffect } from "react";
import PropTypes from "prop-types";

import { connect } from "react-redux";
import { useHistory } from "react-router-dom";
import Alert from "custom/Alert";
import DashboardLayout from "custom/LayoutContainers/DashboardLayout";
import DashboardNavbar from "custom/Navbars/DashboardNavbar";
import SuiBox from "components/SuiBox";
import OrganizationDetails from "../components/organization-details";

const NewOrganization = ({ redirectTo }) => {
  const history = useHistory();

  useEffect(() => {
    if (redirectTo && redirectTo !== "" && redirectTo !== "/organization/new") {
      history.push(redirectTo);
    }
  }, [redirectTo]);

  return (
    <>
      <Alert />
      <DashboardLayout>
        <DashboardNavbar />
        <SuiBox mt={3} mb={8}>
          <OrganizationDetails />
        </SuiBox>
      </DashboardLayout>
    </>
  );
};

NewOrganization.defaultProps = {
  redirectTo: "",
};

NewOrganization.propTypes = {
  redirectTo: PropTypes.string,
};

const mapStateToProps = (state) => ({
  redirectTo: state.ui.redirectTo,
});

export default connect(mapStateToProps, null)(NewOrganization);
